export const JOBS = 'JOBS'
export const JOBS_SUCCESS = 'JOBS_SUCCESS'
export const JOBS_FAILURE = 'JOBS_FAILURE'

export const SUBMIT_APPLICATION = 'SUBMIT_APPLICATION'
export const SUBMIT_APPLICATION_SUCCESS = 'SUBMIT_APPLICATION_SUCCESS'
export const SUBMIT_APPLICATION_FAILURE = 'SUBMIT_APPLICATION_FAILURE'
export const SUBMIT_APPLICATION_RESET = 'SUBMIT_APPLICATION_RESET'
